import {camelCase, mapKeys} from 'lodash';

export class Token {
    constructor({accessToken, refreshToken}) {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
    }

    static createFromApiResponse(response) {
        response = mapKeys(response, (value, key) => camelCase(key));

        return new Token(response);
    }
}